module.exports = __webpack_public_path__ + "img/pay4.bd1bf94a.png";